"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompetitive = void 0;
function isCompetitive(rules) {
    return rules.rankPlayers !== undefined;
}
exports.isCompetitive = isCompetitive;
